import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {setupEnvironment} from './environments/setupEnvironment';

setupEnvironment();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
